var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"my_container"},[_c('el-container',[_c('el-aside',[_c('SideNav')],1),_vm._v(" "),_c('el-main',{staticClass:"mnins"},[_c('el-header',[_c('HeadBlock')],1),_vm._v(" "),_c('AppMain')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bb2c05c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Layout/index.vue
// module id = null
// module chunks = 